import moment from 'moment';
import Constants from "../shared/Constants";
import DateConversion from "./DateConversion";

function uuid() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
    );
}


function getMessageDay(timestamp, timeZoneRegion){
  if(!timestamp){
    return '';
  }
  let momentDate = moment.unix(timestamp);
  let currentMomentDate = moment();
  if(momentDate){
    var timeZoneNumber = DateConversion.fetchTimeZoneByCountry(timeZoneRegion);
    if(Math.sign(timeZoneNumber)===1){
      timeZoneNumber = "GMT +"+timeZoneNumber;
    }
    else{
      timeZoneNumber = "GMT "+timeZoneNumber;
    }
    momentDate = moment.tz(timestamp, timeZoneNumber);

    let date = momentDate.date();
    let month = momentDate.month();
    let year = momentDate.year();
    if(year===currentMomentDate.year() && month===currentMomentDate.month()){
      if(date===currentMomentDate.date()){
        return "Today";
      }
    }
    return momentDate.format(Constants.dateFormat);

  }

  return '-';
}
export {
    uuid,
  getMessageDay,
}